import { BuyerVatInfo } from "@/framework/billing/buyerVatInfo";
import {
  grossPriceForCredits,
  listeningHoursForCredits,
  transcriptionHoursForCredits,
  translationCharactersForCredits,
} from "./creditValue";
import { formatCharacters, formatEurAmount, formatHours } from "./formatting";

// Price of a topup. Until the buyer's country is known the VAT is unknown too,
// so the label carries a disclaimer instead of a number.
export function creditPriceLabel(
  credits: number,
  vatInfo?: BuyerVatInfo,
): string {
  if (!vatInfo) {
    return `${formatEurAmount(credits)} + any applicable VAT`;
  }
  if (vatInfo.vatRate === 0) {
    return vatInfo.isReverseCharge
      ? `${formatEurAmount(credits)} — VAT reverse charge applies`
      : formatEurAmount(credits);
  }
  return `${formatEurAmount(
    grossPriceForCredits(credits, vatInfo.vatRate),
  )} incl. ${Math.round(vatInfo.vatRate * 100)}% VAT`;
}

// Mutually exclusive ways of spending the whole balance, in display order.
export function creditValueOptions(credits: number): string[] {
  return [
    `transcribe ${formatHours(
      listeningHoursForCredits(credits),
    )} of audio minute-by-minute as you listen along`,
    `transcribe ${formatHours(
      transcriptionHoursForCredits(credits),
    )} of audio when transcribing the whole track in one go`,
    `translate ${formatCharacters(
      translationCharactersForCredits(credits),
    )} characters of text`,
  ];
}
